import { IChangeData } from 'libs/shared/src/lib/in-house-input-select/in-house-input-select.model';
import { useState } from 'react';

import { CoursePickerModalProps } from './course-picker-modal.model';
import { CoursePickerModalView } from './course-picker-modal.view';

export const CoursePickerModalController = (props: CoursePickerModalProps) => {
  const [selectedValue, setSelectedValue] = useState<IChangeData>();
  const [version, setVersion] = useState<string>();

  const onPickerValChange = (val: IChangeData) => {
    setSelectedValue(val);
  };

  const onClose = () => {
    setSelectedValue(undefined);
    props.onCloseCourseUpdatePickerModal();
  };

  return (
    <CoursePickerModalView
      {...props}
      {...{
        selectedValue,
        onPickerValChange,
        version,
        setVersion,
        onClose,
      }}
    />
  );
};
